import React from 'react';
import styled from 'styled-components';
import { color } from '../../theme';

const box = {
  height: 200,
  background: color.white,
  width: '49.5%',
  textAlign: 'center',
  lineHeight: '200px',
};

export const RegisterNewsRollCategory = {

  // Internal id of the component
  id: 'newsRollCategory',

  // Visible label
  label: 'Nyheder fra kategori',

  // Fields the user need to fill out when adding an instance of the component
  fields: [{
    label: 'Kategori',
    name: 'category',
    widget: 'file-relation',
    collection: 'settings',
    file: 'categories',
    target_field: 'categories',
    id_field: 'id',
    display_fields: 'name',
    display_summary: '{{name}}',
    multiple: false,
  }],

  // Pattern to identify a block as being an instance of this component
  pattern: /<NewsRoll category="([a-zA-Z0-9_\-]*)" \/>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
      category: match[1],
    };
  },

  // Function to create a text block from an instance of this component
  toBlock({ category }) {

    const id = Array.isArray(category) ? category[0].get('value') : '';

    return `<NewsRoll category="${id}" />`;
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview() {

    return (
      <>
        <h2>Nyheder</h2>
        <section
          style={{
            width: '100%',
            padding: 0,
            minHeight: 200,
            height: 200,
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={box}>Nyhed</div>
          <div style={box}>Nyhed</div>
        </section>
      </>
    );
  },

};
